import MentoringGirlIcon from './MentoringGirlIcon.vue';

export default MentoringGirlIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/girl/index.ts